'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('glider-js');

require('glider-js/glider.min.css');

require('../../styles/components/_article-related-post.scss');

require('../../styles/components/_blog-article.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleRelatedPost = function () {
  function ArticleRelatedPost() {
    (0, _classCallCheck3.default)(this, ArticleRelatedPost);

    this.gliderCreate();
  }

  (0, _createClass3.default)(ArticleRelatedPost, [{
    key: 'gliderCreate',
    value: function gliderCreate() {
      var relatedGlider = document.querySelector('[data-glider-related]');

      if (relatedGlider) {
        // eslint-disable-next-line no-undef
        new Glider(relatedGlider, {
          slidesToShow: 2.4,
          slidesToScroll: 1,
          draggable: true,
          scrollLock: true,
          scrollLockDelay: 200,
          arrows: false,
          responsive: [{
            // screens greater than >= 775px
            breakpoint: 775,
            settings: {
              // Set to `auto` and provide item width to adjust to viewport
              slidesToShow: 3.4
            }
          }, {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              arrows: {
                prev: '.carousel__arrow--prev',
                next: '.carousel__arrow--next'
              }
            }
          }]
        });
      }
    }
  }]);
  return ArticleRelatedPost;
}();

new ArticleRelatedPost();